import { placeholderValue } from './placeholderFill';

export const UNMAPPED_TEMPLATE_MESSAGE = "This template can't be sent from SRM yet (its fields can't be matched). Tell an admin.";
export const parameterLabel = name => String(name).replace(/_/g, ' ').replace(/^./, letter => letter.toUpperCase());
export const componentTemplateText = component => component?.text_named ?? component?.text ?? '';

export function templateParameterFields(template) {
  const parameters = template?.components?.flatMap(component => component.parameters || []) || [];
  const source = parameters.length ? parameters : (template?.customParams || []).map(param => ({ ...param, name: param.name || param.paramName }));
  const unique = new Map();
  source.forEach(field => {
    const name = field.name || field.provider_key || field.key;
    if (!name) return;
    const previous = unique.get(name);
    unique.set(name, { ...field, key: name, name, required: field.required !== false || (previous ? previous.required !== false : false) });
  });
  return [...unique.values()];
}

export function initialTemplateValues(template, context = {}) {
  // A chat picker has no query context. Never copy sample/contact attributes.
  const { chat, customer, authState, assignedAgent } = context;
  return Object.fromEntries(templateParameterFields(template).map(field => [field.name, placeholderValue(field.name, { chat, customer, authState, assignedAgent })]));
}

export function templatePreviewValues(template, values = {}) {
  const named = Array.isArray(values) ? Object.fromEntries(templateParameterFields(template).map((field, i) => [field.name, values[i]])) : values;
  const aliases = { ...named };
  (template?.components || []).forEach(component => (component.parameters || []).forEach(field => {
    const name = field.name || field.provider_key || field.key;
    if (field.key && named[name] !== undefined) aliases[field.key] = named[name];
    if (field.index != null && named[name] !== undefined) aliases[String(field.index)] = named[name];
  }));
  return aliases;
}
export function fillTemplateText(text, values = {}) {
  return String(text ?? '').replace(/\{\{\s*([^{}]+?)\s*\}\}/g, (original, name) => String(values[name.trim()] ?? '').trim() ? String(values[name.trim()]) : original);
}
export function templateBodyText(template) {
  const body = template?.components?.find(component => String(component.type).toLowerCase() === 'body');
  return body ? componentTemplateText(body) : template?.text_named ?? template?.bodyOriginal ?? template?.body ?? '';
}
export function templateParameterError(error) {
  const code = error?.code || error?.response?.data?.error?.code || error?.response?.data?.code;
  if (code === 'MESSAGING_TEMPLATE_PARAMETERS_UNMAPPED') return UNMAPPED_TEMPLATE_MESSAGE;
  if (code === 'MESSAGING_TEMPLATE_PARAMETERS_MISSING') {
    const names = error?.details?.missing_names || error?.response?.data?.error?.details?.missing_names || [];
    return names.length ? `Fill in these fields: ${names.map(parameterLabel).join(', ')}.` : 'Fill in all required template fields.';
  }
  if (code === 'MESSAGING_TEMPLATE_PARAMETERS_INVALID') return 'These template fields could not be matched. Reopen the template or tell an admin.';
  return null;
}
